import React from 'react';
import { getSyncType } from 'common/helpers/getSyncType';

const SyncType = ({ t, externalSystem }) => {
  const syncType = getSyncType(externalSystem);
  return (
    <>
      <span className="sync-status__label">
        {t('cms:cms.properties.homepage.property_management.sync_type')}
      </span>
      <span className="sync-status__value sync-status__sync-type">
        {syncType ? t(`cms:cms.properties.homepage.property_management.${syncType}`) : '-'}
      </span>
    </>
  );
};

export default SyncType;
